import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import { useAppSelector, useAppDispatch } from '../../hooks/hooks'
import {
  refreshSessionToken,
  logoutUser,
  selectIsAuthenticated,
  selectSessionTimeRemaining,
  selectIsSessionExpiringSoon
} from '../../store/slices/SessionSlice'

const SessionWarning: React.FC = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const timeRemaining = useAppSelector(selectSessionTimeRemaining)
  const isExpiringSoon = useAppSelector(selectIsSessionExpiringSoon)
  const { loading } = useAppSelector(state => state.session)

  const dispatch = useAppDispatch()
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    if (!isAuthenticated) return

    if (isExpiringSoon && timeRemaining > 0) {
      setShowWarning(true)
    } else if (timeRemaining <= 0) {
      dispatch(logoutUser())
    } else {
      setShowWarning(false)
    }
  }, [isAuthenticated, isExpiringSoon, timeRemaining, dispatch])

  const handleExtendSession = async () => {
    try {
      const result = await dispatch(refreshSessionToken())
      if (refreshSessionToken.fulfilled.match(result)) {
        setShowWarning(false)
      } else {
        console.error('Session refresh failed')
      }
    } catch (error) {
      console.error('Error refreshing session:', error)
    }
  }

  const handleLogout = () => {
    dispatch(logoutUser())
  }

  const timeLeftSeconds = Math.floor(timeRemaining / 1000)
  const minutes = Math.floor(timeLeftSeconds / 60)
  const seconds = timeLeftSeconds % 60

  return (
    <Modal
      title="Session Expiring Soon"
      open={showWarning}
      footer={[
        <Button key="logout" onClick={handleLogout} disabled={loading}>
          Logout
        </Button>,
        <Button key="extend" type="primary" onClick={handleExtendSession} loading={loading}>
          Extend Session
        </Button>
      ]}
      closable={false}
    >
      <p>Your session will expire in {minutes}:{seconds.toString().padStart(2, '0')} minutes.</p>
      <p>Would you like to extend your session?</p>
    </Modal>
  )
}

export default SessionWarning
